import { useCallback, useState } from 'react'

export const useLocalStore = <R>(
	storeKey: string,
	defaultValue: R,
): [R, (newValue: R) => void] => {
	const existing = localStorage.getItem(storeKey)

	const [value, setValue] = useState<R>(
		existing !== null ? JSON.parse(existing) : defaultValue,
	)

	const setter = useCallback(
		(newValue: R) => {
			localStorage.setItem(storeKey, JSON.stringify(newValue))
			setValue(newValue)
		},
		[storeKey],
	)

	return [value, setter]
}
